module.exports = __webpack_public_path__ + "static/media/484JamesPBrawleyDrNW_2018-06-12_170.6e039ef3.jpg";